import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SkyBoxDetailsComponent } from './sky-box-details/sky-box-details.component';
import { SkyHeaderComponent } from './sky-header/sky-header.component';

@NgModule({
  declarations: [SkyHeaderComponent, SkyBoxDetailsComponent],
  exports: [SkyHeaderComponent, SkyBoxDetailsComponent],
  imports: [CommonModule, RouterModule],
})
export class SharedSkyComponentsModule {}
